import { Component, OnInit, Inject, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SnackService } from '../../shared-services/snack.service';
import { BackendService } from '../../core/backend.service';
import { HistoryProvider } from '../../core/browser-providers';
import { SecurityService } from '../security.service';
import { MediaService } from '../../shared-services/media.service';
import { Http } from '@angular/http';
import { NavigationService } from '../../shared-services/navigation.service';
import { NgForm } from '@angular/forms';
import {FormControl} from '@angular/forms';
import { MatSelectChange, MatAutocompleteSelectedEvent, MatChipInputEvent } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { ENTER } from '@angular/cdk/keycodes';
import { DialogService } from '../../shared-components/modals/dialog.service';
import { Role } from '../role/role.model';
import { User } from './user.model';
import { Genero } from './genero.model';
import { Pais } from './pais.model';
import { TipoDocumento } from './tipo-documento.model';
import { FormValidatorService } from '../../shared-services/form-validator.service';
import { StrengthPasswordService } from '../../shared-services/strength-password.service';
import { OperationalParametric } from '../../cliente/operationalParametric.model';
import { Parametric } from '../../cliente/parametric.model';
import { ApiService } from '../../core/api.service';
import { EmailCliente } from '../../cliente/emailCliente.model';
import { TelefonoCliente } from '../../cliente/telefonoCliente.model';
import { Telefono } from './telefono.model';
import { Foto } from './foto.model';
import { Response } from '@angular/http';
import { ProveedorSimple } from '../../productos/modificacion-precio/proovedor-simple.model';
import { Producto } from '../../productos/producto.model';

@Component({
  selector: 'app-user-add-edit',
  templateUrl: './user-add-edit.component.html',
  styleUrls: ['./user-add-edit.component.scss']
})
export class UserAddEditComponent implements OnInit {

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = false;
  perfil = false;
  separatorKeysCodes: number[] = [ENTER];
  proovedores: ProveedorSimple[]=[];
  proveedorSimple: ProveedorSimple;
  userSellerCenter: boolean = false;

  @ViewChild('form') public userForm: NgForm;

  toppings = new FormControl();
  @ViewChild('fruitInput') fruitInput: ElementRef;

  private TelefonoCliente = new TelefonoCliente();
  private EmailCliente = new EmailCliente();
  validationFail = false;
  user: User;

  messageTitle: string;
  

  isHD = false;

  rol: Role;

  cambiaProveedor: boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private snackService: SnackService,
    private backendService: BackendService,
    private formValidatorService: FormValidatorService,
    private renderer: Renderer2,
    @Inject(HistoryProvider) private history: History,
    private apiService: ApiService,
    private mediaService: MediaService,
    private navigationService: NavigationService,
    private dialogService: DialogService,
    @Inject (StrengthPasswordService) private passwordStrength,
  ) { }

  _selectedRole: Role[] = [];

  roleList: Observable<Role[]>;
  generoList: Observable<Genero[]>;

  ngOnInit() {

    this.getProveedores();

    this.route.data.subscribe(data => {

      this.user = data.user;
      this.user.genero = this.user.genero ? this.user.genero : new OperationalParametric();
      this.user.password = this.user && this.user.password ? this.user.password : null;
      this.user.roles = this.user.id ? this.user.roles : [];
      this.user.fotos = this.user.fotos ? this.user.fotos : [];
      this.user.pais = this.user.pais ? this.user.pais : null;

      if (data.title === 'Perfil') {
        this.perfil = true;
      }

      if (this.user.emails) {
        for (const email of this.user.emails) {
          if (email.principal) {
            this.user.email_direccion = email.direccion;
            break;
          }
        }
      }
      if (!this.user.telefonos || this.user.telefonos.length === 0) {
        this.user.telefonos = [];
        this.user.telefonos.push(new Telefono('', 1));
      } else {
        for (const telefono of this.user.telefonos) {
          switch (telefono.tipoTelefonoId) {
            case this.TelefonoCliente.staticParticular:
              telefono.icono = 'phone';
              break;
            case this.TelefonoCliente.staticCelular:
              telefono.icono = 'phone_android';
              break;
            case this.TelefonoCliente.staticLaboral:
              telefono.icono = 'phonelink_ring';
              break;
            default:
              telefono.icono = 'phone';
          }
        }
      }

      this.getRol();
      this.validateUserSellerCenter();

    });

    this.messageTitle = this.user.id ? 'Edición de usuario' : 'Alta de usuario';

    this.roleList = this.backendService.get(Role, Role.path, {});
    this.generoList = this.backendService.getRawPath(Genero, Genero.path, {});
    this.filter();
    this.mediaService.isHighDefinition.subscribe(isHD => this.isHD = isHD);
  }

  /*
  async getFotoById() {
    this.fotos = [];
    await this.backendService
      .get(Documentacion, Cliente.path + Documentacion.path, null).toPromise().then(res => {
        Array.from(res).forEach(doc => {
          var documentacion = new OperationalDocumentacion();
          Object.assign(documentacion, doc);
          this.documentacionRespaldatoria.push(documentacion);
        });
        for (const documentacion of this.documentacionRespaldatoria) {
          if (documentacion.documentos.length === 0) {
            documentacion.documentos.push(new Documento(undefined));
          }
        };
      });
  }
*/

  back() {
    this.router.navigate(['/usuarios']);
  }

  async save() {
    if (this.validateForm()) {

      if(this.userSellerCenter){
        if(!this.user.proveedorSimple){
          this.snackService.error('Debe Elegir un Proveedor');
          return
        }
      }

      this.invokeSave();
    }
  }

  validateForm() {
    let validationsOK = false;
    if (this.formValidatorService.isFormValid(this.userForm)) {

      if (!this.user.id && this.user.password !== this.user.retryPassword) {
        this.snackService.error('Las claves no coinciden');

        validationsOK = false;
        this.validationFail = true;

        return validationsOK;
      }
      
      if(this.user.roles.length == 0){
        this.snackService.error('Debe elegir al menos un rol');

        validationsOK = false;
        this.validationFail = true;

        return validationsOK;
      }

      validationsOK = true;
      this.validationFail = false;
    } else {
      validationsOK = false;
      this.validationFail = true;
    }

    return validationsOK;
  }

  private async invokeSave() {

    if (this.validateForm()) {
      this.ConfirmSave();
    }
    return;
  }

  remove(role: Role): void {

    const index = this.user.roles.indexOf(role);
    if (index >= 0) {
      this.user.roles.splice(index, 1);
    }
    this.validateUserSellerCenter();
    this.filter();
  }

  selected(event: MatAutocompleteSelectedEvent): void {

    const index = this.user.roles.indexOf(event.option.value);

    if (index >= 0) {
      return;
    }
    this.user.roles.push(event.option.value);
    this.fruitInput.nativeElement.value = '';
    this.toppings.setValue(null);
    // this.renderer.invokeElementMethod(this.fruitInput.nativeElement, 'blur', []);
    this.validateUserSellerCenter();
    this.filter();
  }

  validateUserSellerCenter(){
    var namesUser: string[] = [];
    this.user.roles.forEach(a =>{
      namesUser.push(a.name);
    })
    
    this.userSellerCenter = namesUser.includes('SELLER CENTER');
    
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;
  }

  async ConfirmSave() {
    this.dialogService.confirm(this.messageTitle,
    '¿Está seguro que desea guardar el usuario ' + this.user.name + '?')
    .then( res => {
      if (res) {
        this.saveRole(res);
      }
    });
  }

  async saveRole(res) {
    if (res) {

      this.snackService.spinner(true);
      if (this.user.id) { // Update
        try {
          await await this.backendService.update(User.path + this.user.id, this.user);
          this.saveFotos(this.user.id);
          if (this.perfil) {
            this.snackService.success('Perfil editado');
            this.router.navigate(['/home']);
          } else {
            this.snackService.success('Usuario editado');
            this.router.navigate(['/usuarios']);
          }
        } catch (ex) {
          if (ex[0]) {
            this.snackService.error(ex[0].details);
          } else if (ex.errors) {
            this.snackService.error(ex.errors[0].defaultMessage);
          } else {
            this.snackService.error(ex.message);
          }
        } finally {
          this.snackService.spinner(false);
        }
      } else {
        try {
          const response = await this.backendService.createWithResponse(User.path, this.user);
          const usuarioResponse = JSON.parse((response as Response).text());
          this.saveFotos(usuarioResponse.id);
          this.snackService.success('Usuario creado');
          this.router.navigate(['/usuarios']);
        } catch (ex) {
          if (ex[0]) {
            this.snackService.error(ex[0].details);
          } else if (ex.errors) {
            this.snackService.error(ex.errors[0].defaultMessage);
          } else {
            this.snackService.error(ex.message);
          }
        } finally {
          this.snackService.spinner(false);
        }
      }
    }
  }

  public roleSelected(role: Role): boolean {
    for (const roleUser of this.user.roles) {
      if (role.id === roleUser.id) {
        return true;
      }
    }
    return false;
  }

  private filter() {
    this.roleList
    .map(r => r.filter(p => this._selectedRole.indexOf(p) === 0));
  }

  cambiarPassword() {
    this.router.navigate(['/usuarios/cambiar_mi_password']);
  }

  async saveFotos(userId) {
    try {
      let formdata: FormData;
      const archivos = this.user.fotos;
      for (let i = 0; i < this.user.fotos.length; i++) {
        if (archivos[i].id === undefined && archivos[i].file !== null && archivos[i].file !== undefined) {
          formdata = new FormData();
          formdata.append('file', archivos[i].file);
          formdata.append('name', archivos[i].name);
          formdata.append('id', userId);
          await this.backendService.createFile(User.path + Foto.path, formdata);
        }
      }
    } catch (ex) {
      this.snackService.error(ex.message);
    }
  }

  async getProveedores(){
    this.proovedores = await this.backendService.get(ProveedorSimple,"/new-productos/proveedores",null).toPromise();
  }

  onProvSelect(event){
    this.user.proveedorSimple = event.value;
  }

  onProvSelectConProveedor(event){
    this.user.proveedorSimple = event.value;
    this.cambiaProveedor = true;
    //this.proveedorId = this.producto.proveedor.id;
    
  }

  async getUsuarioInternoProveedor(){
    await this.backendService.get(ProveedorSimple, Producto.newPath+ "proveedor_user/"+this.user.id).toPromise().then(a => {
      this.proveedorSimple = a as ProveedorSimple;
      this.user.proveedorSimple= this.proveedorSimple as ProveedorSimple;
    })
  }

  async getRol(){
    await this.backendService.get(Role,"/new-roles/user/"+this.user.id).toPromise().then(a =>{
      this.rol = a as Role;
    });
    if (this.rol.name == 'SELLER CENTER'){
      this.getUsuarioInternoProveedor();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/security/user/user-add-edit.component.ts